import React, { useState, useEffect } from 'react';
import Login from "../components/Login";
import { connect } from "react-redux";
import { withRouter} from 'react-router-dom'
import { SubmissionError } from 'redux-form';
import { history } from './../helpers/history';
import DialogOTP from '../components/Complements/DialogOTP';
import chargeData from './../actions/chargeCoreData';
import LoadingScreen from '../components/Complements/LoadingScreen';
import {encrypt, sendMobile, decrypt} from './../functions/mobile';
import { servicesSocket } from '../functions/socket';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty } from '../functions/arrays';
import * as allActions from './../functions/loguin-imports'
import { feathersCreateData } from '../services';

const useStyles = makeStyles(theme => ({
    fondo: {
        [theme.breakpoints.up('xs')]: {
            backgroundColor: "#0097a0",
            width : "100%",
            height : "800px"
        },
        [theme.breakpoints.up('sm')]: {
            backgroundColor: "#0097a0",
            width : "100%",
            height : "100vh"
        },
        [theme.breakpoints.up('md')]: {
            backgroundColor: "#0097a0",
            width : "100%",
            height : "100vh"
        },
        [theme.breakpoints.up('lg')]: {
            backgroundColor: "#0097a0",
            width : "100%",
            height : "100vh"
        },
        [theme.breakpoints.up('xl')]: {
            backgroundColor: "#0097a0",
            width : "100%",
            height : "100vh"
        },

    },

}))

const LoginContainer = props => {
    const {devices: deviceReduce,  getDeviceData } = props
    const [ openDialogOTP, setOpenDialogOTP ] = useState(false);
    const [ initialTime, setInitialTime ] = useState(Date.now());
    const [ values, setValues ] = useState({});
    const [ loading, setLoading ] = useState(false);

    // handle
    const handleSubmit = async (values) => {

      // console.log(values);

        try {
            props.loadingState(true)
            values.email = values.email.trim();
            values.password = values.password.trim();

            let resultDevice = {}
            setLoading(true)
            values.strategy = 'local'
            if (isEmpty(deviceReduce)) {
                const deviceInfo = await getDeviceData(null)
                resultDevice = deviceInfo.payload.data
            } else {
                resultDevice = deviceReduce
            }
            const {ip, device, mac} = resultDevice
            values.ip = ip
            values.mac = mac
            values.device = device
            // console.log(values);

            const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATELOGIN', values, type: 13, deviceData: device, ip, mac }))
            // console.log(sendData);

            props.createCodeLogin({ sendData }).then( res => {
                // console.log("****** createCodeLogin ***", res.payload)
                const jsonDecrypt = JSON.parse(decrypt(res.payload.responseData))
                // console.log("****** jsonDecrypt ***", jsonDecrypt)

                const { type } = jsonDecrypt
                props.loadingState(false)
                try {

                    if (type === 'success') {
                        setValues(values)
                        setInitialTime(Date.now())
                        setOpenDialogOTP(true)
                        //this.setState( { values, openDialogOTP: true, otp: result, initialTime: Date.now(), dataCodes: data, contAttemptsAllowed : parseInt(parameters.value), user})
                    } else {
                        const { alert } = jsonDecrypt
                        props.handleOpenSnack(alert,type)
                    }
                    setLoading(false)
                }catch (e) {
                    setLoading(false)
                    props.handleOpenSnack("Ha ocurrido un error al obtener el código OTP.","error");
                }
            }).catch(err => {
                //console.log('error de otp', err)
                setLoading(false)
                props.loadingState(false)
            })
        } catch (error) {
            setLoading(false)
            props.loadingState(false)
            props.handleOpenSnack("Ha ocurrido un error al solicitar código OTP.","error");
            //console.log(' error con CB', error)
        }

    }

    const handleCloseDialogOTP = () => {
        setOpenDialogOTP(false)
        //this.setState({ openDialogOTP: false })
    };

    const handleFingerPrint = () => {
        let send = {
            type: 'action',
            action: 'openFinguerPrint',
            data: true
        }
        sendMobile(JSON.stringify(send))

    };

    const handleChangeInputOtp = (valueinput) => {
        //console.log(valueinput.target.value)
        if(valueinput.target.value.toString().length === 4){
            // console.log("VALUE OTP: ", valueinput)
            receiveOTP({data : valueinput.target.value.toString()});
        }

    }

    // functions
    const receiveOTP = async(value) => {

        try {

            setLoading(true)

            const { data } = value

            let resultDevice = {}
            if (isEmpty(deviceReduce)) {
                const deviceInfo = await getDeviceData(null)
                resultDevice = deviceInfo.payload.data
            } else {
                resultDevice = deviceReduce
            }

            const {ip, device, mac} = resultDevice

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type : 13,
                inputOtp : data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if(error === false){

                handleCloseDialogOTP()
                loginProcess(data)

            }else{

                if(viewDialogOtp === false){
                    handleCloseDialogOTP()
                }
                setLoading(false)
                props.handleOpenSnack(message, type);

            }

        } catch (error) {
            //console.log(error)
            setLoading(false)
            props.handleOpenSnack('Ha ocurrido un error al validar el código.', 'error');
        }

    }

    const dateAfterLogin = (str1) =>
    {
        return new Date(str1) <= new Date();
    }

    const loginProcess = async (inputOtp) => {
        try {
            setLoading(true)
            //console.log(values)

            const sendData = encrypt(JSON.stringify({
                username : values.email,
                password : values.password,
                strategy : values.strategy,
                mac : values.mac,
                ip : values.ip,
                device : values.device,
                otp : inputOtp
            }))

            const login = await props.loginRequest({
                sendData
            })
            const { payload } = login
            //console.log(login)
            if (!payload.error) {
                servicesSocket(payload.user, props)
                //setEmailUser()
                //sendEmailEntrySatisfactory(payload.user.mail);
                if (login.error) {
                    throw new SubmissionError(payload)
                } else {
                    let send = {
                        username: values.email,
                        password: values.password,
                        id: payload.user.vusk,
                        changePass: payload.user.changePass,
                    }

                    if (localStorage.caja_app !== undefined) {
                        const sendEncrypt = encrypt(JSON.stringify(send))
                        sendMobileApp(JSON.parse(sendEncrypt), 'loginSave')
                        sendMobileApp({payload:  payload.accessToken}, 'controlParam')
                    } else {
                        sendMobileApp(send, 'loginSave')
                    }
                    await chargeData(props,payload)
                    let compare_date_change_password = dateAfterLogin(payload.user.nextDateChangePassword);
                    // let compare_date_change_password = dateAfterLogin(payload.user.nextDateChangePassword);
                    setLoading(false)
                    if(compare_date_change_password === true){
                        props.handleOpenSnack('Estimado Usuario, COOP CAJA le recomienda cambiar su contraseña cada cierto tiempo por cuestiones de seguridad de su información.', 'info');
                    }
                    props.loadingState(true)

                    if (payload.user.haveQuestions === 0)
                    {
                        history.push('/questions')
                    } else {
                        if ((payload.user.changePass === 0) || (compare_date_change_password === true))
                        {
                            history.push('/password-change')
                        } else {
                            history.push('/')
                        }
                    }

                }
            } else {
                setLoading(false)
                props.handleOpenSnack(payload.message, 'error')
            }
        } catch (error) {
            setLoading(false)
            props.logoutAction()
            props.resetStore()
            props.handleOpenSnack('No se puede conectar al servidor. Por favor vuelva a intentar', 'error')

        }
    }

    const mount = () => {
        const unmount =  () => {
            sendMobileApp({ data:'' }, 'compareLogin')
        }
        return unmount()
    }

    useEffect(mount, [])

    /* const componentDidMount = () => {
        sendMobileApp({ data: ''}, 'compareLogin')
        // isMobile && client.on('login', (authResult, params, context) => history('/'))
    } */


    const sendMobileApp = (data, type) => {
        let send = {
            type,
            data
        }
        sendMobile(JSON.stringify(send)) // window.postMessage('hola')
    }

        const classes = useStyles();

        return (
            <div className = { classes.fondo }>
                <LoadingScreen
                    open={loading}
                />
                <Login
                    onSubmit = { handleSubmit }
                    finguerprint = { handleFingerPrint }
                />
                <DialogOTP
                    openDialogOTP = {openDialogOTP}
                    loading = { loading }
                    initialTime = {initialTime}
                    showQR = {false}
                    onCloseDialogOTP = { handleCloseDialogOTP }
                    onKeyPress = { handleChangeInputOtp }
                    OTPSubmit = { receiveOTP }
                />
            </div>
        );

}
// obtener datos de la sesion

/* const mapStateToProps = state => ({
    isAuthenticated: state.auth.isSignedIn,
}) */

const mapState = (state) => {
    const { loggingIn } = state.authentication;
    const { authentication, devices } = state
    return { loggingIn, authentication, devices };
}




LoginContainer.propTypes = {
    // loginUser: PropTypes.func.isRequired,
    // handleRecover: PropTypes.func.isRequired,
};

export default withRouter(connect(mapState, {...allActions} )(LoginContainer));
